import React, { useState } from 'react';
import { FieldError } from 'react-hook-form';
import Input from '../../../../../Components/Form/components/Input';
import styles from './Password.module.scss';
import usePasswordChecklist from '../../../Hooks/usePasswordChecklist';
import PasswordChecklist from 'react-password-checklist';
import Text from '../../../../../Components/Base/Text/Text';

interface Props {
	value?: string;
	error?: FieldError;
	onChange?: React.FormEventHandler<HTMLInputElement>;
	placeholder?: string;
	loadChecklist?: boolean;
	description?: string;
}

const Password: React.FC<Props> = ({
	value,
	error,
	onChange,
	placeholder,
	loadChecklist,
	description,
}) => {
	const [isHidden, setIsHidden] = useState(true);
	const { checklist, rules, messages, minLength, maxLength } =
		usePasswordChecklist({
			loadChecklist,
		});

	return (
		<>
			<div className={styles.wrapper}>
				<Input
					type={isHidden ? 'password' : 'text'}
					value={value}
					hasError={Boolean(error?.message)}
					onChange={onChange}
					placeholder={placeholder}
				/>
				<div className={styles.iconWrapper}>
					<img
						src='/dist/patientV3/icons/eye-solid.svg'
						alt='eye'
						onClick={() => setIsHidden(prev => !prev)}
					/>
				</div>
				{description && (
					<Text tx={description} className={styles.description} />
				)}
			</div>
			{checklist && value && (
				<PasswordChecklist
					rules={rules}
					className='checklist'
					value={value}
					minLength={minLength}
					maxLength={maxLength}
					messages={messages}
				/>
			)}
		</>
	);
};

export default Password;
